import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Layout/Breadcrumb";

import FormStep2 from "./FormStep2";
import { useParams } from "react-router-dom";

const Edit = () => {
  const [searchParams] = useSearchParams();

  const { id, immigration_id, application_id } = useParams();
  const renewal_id = searchParams.get("renewal_id");
  const { t } = useTranslation();

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "/immigration/list",
      label: t("List view"),
      active: false,
    },
    {
      url: "#",
      label: `${t("Update")} ${t("immigration")}`,
      active: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle={`${t("Visa / Work Permit Tracking")}`}
            breadcrumbItems={breadcrumbItems}
          />
          <FormStep2
            id={id}
            immigration_id={immigration_id}
            application_id={application_id}
            renewal_id={renewal_id}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Edit;
